module.exports = __webpack_public_path__ + "img/5_gender_equality_color.733f8633.svg";